import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useRef} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

export interface ActiveEnzymeItemProps {
  /** A CSS hex code; the color swatch to display next to tne enzyme */
  color: string;
  /** A function to be called when the enzyme is clicked */
  onClick: () => void;
  /** A function to be called when the enzyme is un-hovered */
  onMouseOut: () => void;
  /** A function to be called when the enzyme is hovered */
  onMouseOver: (offset: number) => void;
  /** The name of the enzyme */
  name: string;
}

export default function ActiveEnzymeItem({
  color,
  onClick,
  onMouseOut,
  onMouseOver,
  name,
}: ActiveEnzymeItemProps): JSX.Element {
  const ref = useRef<HTMLTableRowElement | null>(null);

  return (
    <tr
      onClick={onClick}
      onMouseOut={onMouseOut}
      onMouseOver={() => {
        if (ref.current != null && ref.current.offsetParent != null) {
          // offsetTop is calculated once at initial render time and does not update when the parent element
          // is scrolled, so we have to calculate the offset manually based on how far the scrollbar is.
          onMouseOver(ref.current.offsetTop - ref.current.offsetParent.scrollTop);
        }
      }}
      ref={ref}
      {...getTestProps({component: 'ActiveEnzymeItem', element: 'row'})}
      className={css(styles.wrapper)}
    >
      <td className={classNames('mono', css(styles.enzymeNameCell))}>{name}</td>
      <td className={css(styles.swatchCell)}>
        <div className={classNames('swatch', css(styles.swatch))} style={{backgroundColor: color}} />
      </td>
    </tr>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    cursor: 'pointer',
  },
  enzymeNameCell: {
    width: '120px',
    textAlign: 'left',
  },
  swatchCell: {
    width: '80px',
  },
  swatch: {
    marginTop: '5px',
  },
});
